"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactMotion = require("react-motion");
var _createClassName = _interopRequireDefault(require("../../utils/createClassName"));
var _utils = require("./utils");
var _Alert = require("./styled/Alert");
var _excluded = ["id", "removeAlert", "message", "showIcon", "type", "className", "time", "hideStartStyle", "icon", "showEndStyle", "showStartStyle", "hideEndStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Alert(_ref) {
  var id = _ref.id,
    removeAlert = _ref.removeAlert,
    message = _ref.message,
    showIcon = _ref.showIcon,
    type = _ref.type,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? 4000 : _ref$time,
    _ref$hideStartStyle = _ref.hideStartStyle,
    hideStartStyle = _ref$hideStartStyle === void 0 ? {
      opacity: 1,
      top: 0
    } : _ref$hideStartStyle,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$showEndStyle = _ref.showEndStyle,
    showEndStyle = _ref$showEndStyle === void 0 ? {
      opacity: (0, _reactMotion.spring)(1),
      top: (0, _reactMotion.spring)(0)
    } : _ref$showEndStyle,
    _ref$showStartStyle = _ref.showStartStyle,
    showStartStyle = _ref$showStartStyle === void 0 ? {
      opacity: 0,
      top: -100
    } : _ref$showStartStyle,
    _ref$hideEndStyle = _ref.hideEndStyle,
    hideEndStyle = _ref$hideEndStyle === void 0 ? {
      opacity: (0, _reactMotion.spring)(0),
      top: (0, _reactMotion.spring)(100)
    } : _ref$hideEndStyle,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)({
      removing: false
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var removing = state.removing;
  var remove = function remove() {
    (0, _utils.removeSelf)(setState, true);
  };
  (0, _react.useEffect)(function () {
    var timeOutID;
    if (time) {
      timeOutID = setTimeout(function () {
        remove();
      }, time);
    }
    return function () {
      if (timeOutID) {
        clearTimeout(timeOutID);
      }
    };
  }, [time]);
  var onRest = function onRest() {
    (0, _utils.handleRest)(removeAlert, removing, id);
  };
  return /*#__PURE__*/_react.default.createElement(_reactMotion.Motion, {
    defaultStyle: removing ? hideStartStyle : showStartStyle,
    onRest: onRest,
    style: removing ? hideEndStyle : showEndStyle
  }, function (_ref2) {
    var opacity = _ref2.opacity,
      top = _ref2.top;
    return /*#__PURE__*/_react.default.createElement(_Alert.AlertStyled, (0, _extends2.default)({
      className: (0, _createClassName.default)('Alert', className, ''),
      onClick: remove,
      style: {
        opacity: opacity,
        top: "".concat(top, "px")
      },
      type: type
    }, rest), /*#__PURE__*/_react.default.createElement(_Alert.AlertBodyStyled, {
      className: (0, _createClassName.default)('Alert', className, '__body')
    }, showIcon && /*#__PURE__*/_react.default.createElement(_Alert.AlertIconWrapperStyled, {
      className: (0, _createClassName.default)('Alert', className, '__body__icon-wrapper')
    }, icon), /*#__PURE__*/_react.default.createElement(_Alert.AlertMessageStyled, {
      className: (0, _createClassName.default)('Alert', className, '__body__message')
    }, message)));
  });
}
var _default = exports.default = Alert;